import { Bar, Doughnut, HorizontalBar, mixins } from 'vue-chartjs';

/**
 * Wraps a vue-chartjs chart so it takes `chartData` and `options` props and redraws when `chartData` changes.
 * The chart fills its container: pass its size through the `styles` prop, e.g. `{ height: '240px', position: 'relative' }`.
 */
function reactiveChart (baseChart) {
  return {
    extends: baseChart,
    mixins: [mixins.reactiveProp],
    props: {
      options: {
        default: () => ({}),
        type: Object
      }
    },
    mounted () {
      this.renderChart(this.chartData, this.options);
    }
  };
}

export const BarChart = reactiveChart(Bar);
export const DoughnutChart = reactiveChart(Doughnut);
export const HorizontalBarChart = reactiveChart(HorizontalBar);
